/* src/app/private/shared/component/sidebar/sidebar.component.scss */
.sidebar {
  width: 54px;
  height: 100vh;
  background-color: var(--p-text-muted-color);
  color: white;
  transition: width 0.3s ease;
  overflow: hidden;
  position: fixed;
  left: 0;
  z-index: 100;
}
.sidebar.expanded {
  width: 210px;
}
.pin-icon {
  padding: 15px;
  text-align: right;
  cursor: pointer;
}
ul {
  list-style-type: none;
  padding: 0;
  margin: 0;
}
li {
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  padding: 15px;
  cursor: pointer;
  transition: background-color 0.3s ease;
  position: relative;
}
.nav-list-item.active {
  background-color: rgba(0, 0, 0, 0.5411764706) !important;
  color: white;
  font-weight: bold;
}
.nav-sub-menu.active {
  background-color: rgba(0, 0, 0, 0.5411764706) !important;
  color: white;
  font-weight: bold;
}
i {
  margin-right: 15px;
  width: 20px;
  text-align: center;
}
span {
  white-space: nowrap;
}
.has-submenu {
  display: flex;
}
.submenu {
  list-style-type: none;
  padding: 0;
  margin: 0;
  margin-top: 0px;
  margin-bottom: 0px;
  background: rgba(128, 128, 128, 0.2196078431);
  width: 100%;
}
.submenu li {
  padding: 10px 20px;
  font-size: 14px;
}
.submenu li:hover {
  background-color: rgba(73, 71, 71, 0.3803921569);
}
.submenu-icon {
  transition: transform 0.3s ease;
}
.submenu-icon.open {
  transform: rotate(180deg);
}
.nav-list-item {
  padding: 15px 20px;
}
.nav-list-item:hover {
  background-color: rgba(73, 71, 71, 0.3803921569);
}
.nav-list-item.active {
  background-color: rgba(0, 0, 0, 0.5411764706) !important;
  color: white;
  font-weight: 500;
  position: relative;
}
.nav-list-item.active::before {
  content: "";
  position: absolute;
  left: 0;
  top: 0;
  width: 5px;
  height: 100%;
  background-color: #F0950C;
}
.nav-sub-menu.active {
  background-color: rgba(0, 0, 0, 0.5411764706) !important;
  color: white;
  font-weight: 500;
}
.nav-sub-menu.active::before {
  content: "";
  position: absolute;
  left: 0;
  top: 0;
  width: 5px;
  height: 100%;
  background-color: #F0950C;
}
p-iconfield {
  transition: max-height 0.5s ease-in-out, opacity 0.3s ease;
  overflow: hidden;
  max-height: 0;
  opacity: 0;
}
.search-bar {
  transition: max-height 0.5s ease-in-out, opacity 0.3s ease;
  overflow: hidden;
  max-height: 0;
  opacity: 0;
}
.search-bar.expanded {
  max-height: 100px;
  opacity: 1;
}
.search-bar.collapsed {
  max-height: 0;
  opacity: 0;
}
.sidebar-scroll {
  overflow-y: auto;
}
.sidebar-scroll::-webkit-scrollbar {
  display: none;
}
.sidebar-scroll::-webkit-scrollbar-thumb {
  display: none;
}
/*# sourceMappingURL=sidebar.component.css.map */
